// conts/PagesMetaData.ts

const pathMetaData: {
  [key: string]: { title?: string; description?: string; imageUrl?: string };
} = {
  "/": {
    title: "DeepMode | AI Character Creation & Art Generator ",
    description: "Create unique AI-generated art with DeepMode. Our advanced AI models let you design custom characters and produce stunning digital images. Explore the future of AI-powered creativity today.",
  },
  "/nsfw":{
    title: "DeepMode NSFW | Adult AI Art Generator (18+) ",
    description: "Discover DeepMode's NSFW AI art generator for adults. Create mature-themed digital art with our advanced AI models. Explore adult-oriented character creation in a safe, controlled environment. 18+ only.",
  },

};

export default pathMetaData;
